/**
 * @generated SignedSource<<47aace926984be05c72f117ff8717bf1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainSubTodos_todoWorkspace$data = {
  readonly id: string;
  readonly subWorkspaceTodos: ReadonlyArray<{
    readonly id: string;
    readonly priority: TodoPriority;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItemDescription_todo">;
  }> | null;
  readonly " $fragmentType": "WorkspaceTodoEditMainSubTodos_todoWorkspace";
};
export type WorkspaceTodoEditMainSubTodos_todoWorkspace$key = {
  readonly " $data"?: WorkspaceTodoEditMainSubTodos_todoWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainSubTodos_todoWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainSubTodos_todoWorkspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoWorkspace",
      "kind": "LinkedField",
      "name": "subWorkspaceTodos",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceTodoListItemDescription_todo"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priority",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "e3c24d3d371ac23514d59619bb558b4e";

export default node;
